import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/exalab-logo-blanco.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"footer__top\"><div class=\"footer__col\"><img class=\"footer__logo\" src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"footer__col\"><div class=\"footer__social social\"><ul class=\"social__ul\"><li class=\"social__li\"><a href=\"#\" class=\"social__a\"><i class=\"social__i ri-facebook-circle-line\"></i></a></li><li class=\"social__li\"><a href=\"#\" class=\"social__a\"><i class=\"social__i ri-instagram-line\"></i></a></li><li class=\"social__li\"><a href=\"#\" class=\"social__a\"><i class=\"social__i ri-twitter-x-line\"></i></a></li><li class=\"social__li\"><a href=\"#\" class=\"social__a\"><i class=\"social__i ri-whatsapp-line\"></i></a></li></ul></div></div></div>", 1)
const _hoisted_4 = { class: "footer__main" }
const _hoisted_5 = { class: "footer__col" }
const _hoisted_6 = { class: "footer__menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "footer__menu--h4" }, " Menú ", -1)
const _hoisted_8 = { class: "footer__menu--ul" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "footer__menu--li" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "footer__menu--a"
  }, " Inicio ")
], -1)
const _hoisted_10 = { class: "footer__menu--li" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", { class: "footer__menu--li" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "footer__menu--a"
  }, " Productos ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", { class: "footer__menu--li" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "footer__menu--a"
  }, " Testimonios ")
], -1)
const _hoisted_13 = { class: "footer__menu--li" }
const _hoisted_14 = { class: "footer__col" }
const _hoisted_15 = { class: "footer__menu" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "footer__menu--h4" }, " Exalab Core ", -1)
const _hoisted_17 = { class: "footer__menu--ul" }
const _hoisted_18 = { class: "footer__col" }
const _hoisted_19 = { class: "footer__menu" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", { class: "footer__menu--h4" }, " Plugins ", -1)
const _hoisted_21 = { class: "footer__menu--ul" }
const _hoisted_22 = { class: "footer__col" }
const _hoisted_23 = { class: "footer__menu" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h4", { class: "footer__menu--h4" }, " Legal ", -1)
const _hoisted_25 = { class: "footer__menu--ul" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "footer__copy" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "footer__copy--span" }, " Copyright © 2024 Ingeniería en Informática MDTech Ltda. contacto@exalabcloud.cl ")
], -1)

import { onMounted, Ref, ref } from 'vue';
import LegalService from '@/services/LegalService';
import Policy from '@/entities/Policy';
import ModulosService from '@/services/ModulosService';
import Modulos from '@/entities/Modulos';
import PluginsService from '@/services/PluginsService';
import Plugins from '@/entities/Plugins';


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterBar',
  setup(__props) {

const legalService: Ref<LegalService> = ref(new LegalService());
const policies: Ref<Policy[]> = ref<Policy[]>([]);

const modulosService: Ref<ModulosService> = ref(new ModulosService());
const modulos: Ref<Modulos[]> = ref<Modulos[]>([]);

const pluginsService: Ref<PluginsService> = ref(new PluginsService());
const plugins: Ref<Plugins[]> = ref<Plugins[]>([]);

onMounted(async () => {
  await getPolicy();
  await getModulos();
  await getPlugins();
});

const getPolicy = async () => {
  policies.value = await legalService.value.getPolicies();
};

const getModulos = async () => {
  modulos.value = await modulosService.value.getModulos();
};

const getPlugins = async () => {
  plugins.value = await pluginsService.value.getPlugins();
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("ul", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'home', hash: '#security' },
                  class: "footer__menu--a"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Nosotros ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'price', hash: '#contact' },
                  class: "footer__menu--a"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Contacto ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("ul", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulos.value, (modulo) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: modulo.id,
                  class: "footer__menu--li"
                }, [
                  _createVNode(_component_RouterLink, {
                    class: "footer__menu--a",
                    to: { name: 'services', params: { id: modulo.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(modulo.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("ul", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plugins.value, (plugin) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: plugin.id,
                  class: "footer__menu--li"
                }, [
                  _createVNode(_component_RouterLink, {
                    class: "footer__menu--a",
                    to: { name: 'plugins', params: { id: plugin.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(plugin.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("ul", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(policies.value, (p) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: p.id,
                  class: "footer__menu--li"
                }, [
                  _createVNode(_component_RouterLink, {
                    class: "footer__menu--a",
                    to: { name: 'policy', params: { linkName: p.link_name } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(p.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _hoisted_26
    ])
  ]))
}
}

})